/**
 * Singleton QueryClient + namespaced key factory for the portal. Defaults
 * mirror the admin console: 30s staleTime, 5min gcTime, no refetch-on-focus,
 * and `retry: false` so 401/404/409 surface immediately instead of being
 * silently retried.
 */

import { makeKeys } from '@evt/flow-stream-ui'
import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: false
    }
  }
})

/** Cache keys, namespaced to `portal` so a shared cache can't collide with admin. */
export const keys = makeKeys('portal')

/** `/api/me` lives outside the shared factory — its own stable key. */
export const meKey = ['portal', 'me'] as const

/** `/api/home` overview aggregate — outside the shared factory, like `meKey`. */
export const homeKey = ['portal', 'home'] as const

/** `/api/memories` — what the Smiths remember for this person. Its own key, like the two above. */
export const memoriesKey = ['portal', 'memories'] as const

/**
 * The public rating context for one link — shared by the `/avaliar/:token` page and the run
 * page's rating card, so a submission in one is what the other reads back.
 */
export const feedbackContextKey = (token: string) => ['portal', 'feedback-context', token] as const
